<form
    id="planInformationForm"
    #planInformationForm="ngForm"
    class="planInformationForm"
    novalidate
    autocomplete="off"
    data-test-automation="plan-information">
    <h4>Plan Information</h4>
    @if (informationUiConfig.surveyorDetailsDisplay) {
        <nlr-surveyor-details />
    }
    <nlr-plan-details [hidden]="!informationUiConfig.planDetailsDisplay" />
    <nlr-tenure [hidden]="!isFormerTenureEnabled()" />
    @if (isLocalityEnabled()) {
        <nlr-locality-and-lga />
    }
    @if (isSurveyDetailsEnabled()) {
        <nlr-survey-details />
    } @else if (isDigitalPlan()) {
        <div
            class="container-fluid well"
            data-test-automation="projected-coord-system">
            <div class="row">
                <div class="col-xs-4">
                    <nlr-projected-coord-system />
                </div>
            </div>
        </div>
    }
    @if (isCompiledFromEnabled()) {
        <nlr-compiled-from />
    }
    @if (isFieldRecordEnabled()) {
        <nlr-field-record />
    }
    <nlr-planning-authority />
    @if (isRoadsEnabled()) {
        <nlr-road />
    }
    @if (isStrataSchemaDetailsEnabled()) {
        <nlr-strata-schema-details />
    }
    @if (isCrownStateLandEnabled()) {
        <nlr-crown-state-land />
    }
    <div class="container-fluid">
        <div class="row buttons">
            <div class="button-group">
                @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                    <button
                        id="saveInformationPageBtn"
                        type="button"
                        class="btn btn-default nlr-btn-sm validate"
                        title="Save Information page data | Ctrl+S"
                        (click)="save()"
                        nlr-click-once
                        [disabled]="saveDisabled() || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                        data-test-automation="save-plan-information">
                        Save
                        <i
                            class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                            style="display: none;"></i>
                    </button>
                }
                @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
                    <button
                        id="validateInformationPageBtn"
                        type="button"
                        class="btn btn-default nlr-btn-sm validate"
                        title="Validate Information page data | V"
                        (click)="validate()"
                        [disabled]="validateDisabled() || (['EDIT_PLAN', 'VIEW_PLAN'] | disabledByPermissions)"
                        nlr-click-once
                        data-test-automation="validate-plan-information">
                        Validate
                        <i
                            class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                            style="display: none;"></i>
                    </button>
                }
                @if ((['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)||readonly) {
                    <button
                        id="cancelInformationPageBtn"
                        type="button"
                        class="btn btn-warning nlr-btn-sm"
                        (click)="cancel()"
                        [disabled]="readonly || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)"
                        title="Clears all data on the Information screen"
                        data-test-automation="cancel-plan-information"
                        >Cancel
                    </button>
                }
            </div>
        </div>
    </div>
</form>
